import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookiesPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4F5FE]">
      {/* Header */}
      <header className="bg-[#0A0A12] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <img src="/logo-fascinai.png" alt="FASCINAI" className="h-8 w-auto" />
          <Button 
            variant="ghost" 
            onClick={() => navigate(-1)}
            className="text-white/60 hover:text-white hover:bg-white/10"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
          <h1 className="text-3xl font-bold text-[#1A1C2E] mb-2">Política de Cookies</h1>
          <p className="text-gray-500 mb-8">Última actualización: 8 de marzo de 2026</p>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-600">
            <p>
              Este portal, al igual que la mayoría de portales en Internet, usa cookies para mejorar la experiencia de navegación del usuario.
            </p>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">¿Qué son las Cookies?</h2>
            <p>
              Las cookies son pequeños archivos que algunas plataformas, como las páginas web, pueden instalar en su ordenador, smartphone, tableta o televisión conectada, al acceder a las mismas.
            </p>
            <p>
              Sus funciones pueden ser muy variadas: almacenar sus preferencias de navegación, recopilar información estadística, permitir ciertas funcionalidades técnicas, almacenar y recuperar información sobre los hábitos de navegación.
            </p>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">¿Por qué son Importantes?</h2>
            <p>Las cookies son útiles por varios motivos:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Permiten que las páginas web funcionen de forma más ágil y adaptada a las preferencias del usuario</li>
              <li>Ayudan a los responsables de los sitios web a mejorar los servicios gracias a la información estadística</li>
              <li>Sirven para hacer más eficiente la publicidad</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">Tipos de Cookies que Utilizamos</h2>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Cookies de Mejora del Rendimiento</h3>
            <p>Conservan sus preferencias para ciertas herramientas o servicios para que no tenga que reconfigurarlos cada vez que visita nuestro portal.</p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Cookies de Análisis Estadístico</h3>
            <p>Permiten cuantificar el número de visitantes y analizar estadísticamente la utilización que hacen los usuarios de nuestros servicios. Gracias a ellas podemos estudiar la navegación por nuestra página web y mejorar la oferta de productos o servicios.</p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Cookies de Registro</h3>
            <p>Le identifican como usuario registrado e indican cuándo se ha identificado en la web. Estas cookies se mantienen mientras no abandone la cuenta, cierre el navegador o apague el dispositivo.</p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Cookies Publicitarias</h3>
            <p>Permiten gestionar eficazmente los espacios publicitarios de nuestro sitio web, adecuando el contenido del anuncio al contenido del servicio solicitado.</p>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">Cookies de Terceros</h2>
            <p>Esta web utiliza servicios de terceros que pueden instalar cookies:</p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Google Analytics</h3>
            <p>
              Servicio analítico de web prestado por Google, Inc. Google Analytics utiliza "cookies" para ayudar a fascinai.pro a analizar el uso que hacen los usuarios del sitio web.
            </p>
            <p>
              La información que genera la cookie acerca de su uso (incluyendo su dirección IP) será directamente transmitida y archivada por Google en los servidores de Estados Unidos.
            </p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Stripe</h3>
            <p>Para procesamiento de pagos. Stripe utiliza cookies para proporcionar sus servicios de forma segura.</p>

            <h3 className="text-lg font-semibold text-[#1A1C2E] mt-6 mb-3">Redes Sociales</h3>
            <p>Las cookies de redes sociales pueden almacenarse en su navegador cuando utiliza botones de compartir contenidos:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Cookies de Facebook — <a href="https://www.facebook.com/policies/cookies/" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">https://www.facebook.com/policies/cookies/</a></li>
              <li>Cookies de Twitter — <a href="https://twitter.com/privacy" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">https://twitter.com/privacy</a></li>
              <li>Cookies de LinkedIn — <a href="https://www.linkedin.com/legal/cookie-policy" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/legal/cookie-policy</a></li>
            </ul>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">¿Cómo Configurar tus Preferencias?</h2>
            <p>Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones de tu navegador:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Google Chrome — <a href="https://support.google.com/chrome/answer/95647" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">https://support.google.com/chrome/answer/95647</a></li>
              <li>Mozilla Firefox — <a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">support.mozilla.org</a></li>
              <li>Internet Explorer / Edge — <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">support.microsoft.com</a></li>
              <li>Safari — <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" className="text-[#4E62F4] hover:underline" target="_blank" rel="noopener noreferrer">support.apple.com</a></li>
            </ul>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">¿Qué Ocurre si se Deshabilitan?</h2>
            <p>En el caso de bloquear o no aceptar la instalación de cookies es posible que ciertos servicios ofrecidos por nuestro sitio web queden deshabilitados y, por lo tanto, no estén disponibles para usted.</p>
            <p>Es posible también que la calidad de funcionamiento de la página web pueda disminuir.</p>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">Aceptación de Cookies</h2>
            <p>Si usted sigue navegando después de haberle informado sobre nuestra Política de cookies entendemos que acepta la utilización de las cookies.</p>
            <p>Al acceder a este sitio web por primera vez, verá una ventana donde se le informa de la utilización de las cookies. Si usted consiente, continúa navegando o hace clic en algún link se entenderá que ha consentido nuestra política de cookies.</p>

            <h2 className="text-xl font-bold text-[#1A1C2E] mt-10 mb-4">Contacto</h2>
            <p>Para cualquier consulta sobre esta política de cookies, puedes contactarnos en:</p>
            <ul className="list-none space-y-2">
              <li><strong>Email:</strong> soporte@fascinai.pro</li>
              <li><strong>Dirección:</strong> Juez José Bernabeu Rocamora, 31 - 03348 Granja de Rocamora (Alicante)</li>
            </ul>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0A0A12] py-8 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xs text-white/30">© 2026 Fascinads Soluciones SL</p>
        </div>
      </footer>
    </div>
  );
};

export default CookiesPolicy;
